import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import type { ClientStatistic } from '../../common/types/statistics/fbStatistics';

type Props = {
  clientStatistics: ClientStatistic;
};

function AgeStatistic({ clientStatistics }: Props) {
  const { ageStatistic } = clientStatistics;

  const data = Object.keys(ageStatistic).map((ageKey) => {
    const numberOfAges = ageStatistic[ageKey];
    const label = numberOfAges === 1 ? 'Person' : 'Personen';
    return {
      title: ageKey,
      label: `${label}`,
      numberOfAges: numberOfAges,
    };
  });

  return (
    <Stack direction='column'>
      <Typography fontWeight='bold'>Alter</Typography>
      {data.map((entry) => (
        <Typography key={entry.title}>
          {entry.title}: {entry.numberOfAges} {entry.label}
        </Typography>
      ))}
    </Stack>
  );
}

export default AgeStatistic;
